"use client";

import { PublicStudySetsInfinite } from "@/features/studysets/components/public-studysets-infinite";
import { useI18n } from "@/locales/client";
import { SubjectListSlider } from "./subject-list-slider";

const PublicStudySetsLibrary = () => {
  const t = useI18n();
  return (
    <div className="flex flex-col h-full w-full">
      <main className="flex-grow w-full">
        {/* Header reference element */}
        <div className="py-4 md:py-8 container w-full flex flex-col gap-6">
          <div className="flex flex-col gap-6 w-full">
            <div className="flex flex-col gap-6">
              <h1 className="text-2xl md:text-3xl font-medium">
                {t("publicLibrary")}
              </h1>
            </div>
            <div className="w-full">
              <SubjectListSlider />
            </div>
          </div>
          <div className="flex flex-col gap-6 w-full">
            {/* Study Sets Grid */}
            <PublicStudySetsInfinite />
          </div>
        </div>
      </main>
    </div>
  );
};

export default PublicStudySetsLibrary;
